const apiVersion = 'v1'

export const BASE_PATH = (type) =>
  `api/${apiVersion}/clients/:client_session_id/automations/validate-duplicates${type ? `-${type}` : ''}/`
